import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterContentInit {

  @Input() public appAutoFocus: boolean;

  constructor(
    private element: ElementRef
  ) { }

  /**
   * Lifecycle hook : AfterContentInit
   */
  public ngAfterContentInit(): void {
    setTimeout(() => {
      //focus on element
      this.element.nativeElement.focus();
    }, 100);
  }

}
